import { useTranslation } from 'react-i18next';
import {
  isServiceProvidedAtHome,
  isServiceLocationStore,
  isServiceProvidedRemote,
  isStoreService,
  isStoreRemoteInConsolidatedCalendar,
} from '../helpers/appHelper';
import { useStateSelector } from '../store/';
import {
  selectLocationForTheSelectedTimeSlot,
  selectServiceIdForTheSelectedTimeSlot,
  selectStoreForTheSelectedTimeSlot,
} from '../reducers/selectors';

interface UseRenderLocationDetailStates {
  locationAddress: string;
  locationName: string;
  locationToCalendar: string;
  locationZipCode: string;
  locationTypeIcon: string;
  locationTypeMessage: string;
}

export default function useRenderLocationDetail(): [
  UseRenderLocationDetailStates,
] {
  const { t } = useTranslation();
  const serviceId = useStateSelector(selectServiceIdForTheSelectedTimeSlot);
  const store = useStateSelector(selectStoreForTheSelectedTimeSlot);
  const location = useStateSelector(selectLocationForTheSelectedTimeSlot);
  const contact = useStateSelector((state) => state.contact);

  let locationName = '';
  let locationAddress = '';
  let locationToCalendar = '';
  let locationZipCode = '';
  let locationTypeIcon = '';
  let locationTypeMessage = '';

  if (location) {
    if (isStoreRemoteInConsolidatedCalendar(location, serviceId, CSS_CONFIG)) {
      locationZipCode = 'all';
    } else if (store && isStoreService(location)) {
      locationZipCode = store.zipCode;
    } else {
      locationZipCode = 'REMOTE';
    }

    if (store && isServiceLocationStore(location)) {
      const { street, zipCode, city, text } = store;
      locationName = text;
      locationAddress = `${street}, ${zipCode}, ${city}`;
      locationToCalendar = [text, street, zipCode, city].join(', ');
      locationTypeIcon = 'store';
      locationTypeMessage = t('pages.confirm.typeOfAppointment.inStore');
    } else if (isServiceProvidedAtHome(location)) {
      const { firstName, surName, address1, address2, city, postCode } =
        contact;
      locationName = firstName
        ? t('pages.confirm.userName', { firstName, surName })
        : '';
      const address = [address1, address2, postCode, city]
        .filter(Boolean)
        .join(', ');
      locationAddress = address;
      locationToCalendar = address;
      locationTypeIcon = 'home';
      locationTypeMessage = t('pages.confirm.typeOfAppointment.atHome');
    } else if (isServiceProvidedRemote(location)) {
      const { address1, address2, city, postCode } = contact;
      locationName = t('pages.confirm.remoteServiceLocation');
      locationToCalendar = [address1, address2, postCode, city]
        .filter(Boolean)
        .join(', ');
      locationTypeIcon = 'remote';
      locationTypeMessage = t('pages.confirm.typeOfAppointment.remote');
    } else {
      locationTypeIcon = 'remote';
      locationTypeMessage = '';
    }
  }

  return [
    {
      locationAddress,
      locationName,
      locationToCalendar,
      locationZipCode,
      locationTypeIcon,
      locationTypeMessage,
    },
  ];
}
